import React, { useContext } from 'react'
import CommonContext from '../../../hooks/CommonContext';
import ReactPaginate from 'react-paginate';

const HomePagination = () => {
    const {
        sendingDataForProfessionalSearch, setapplyFilterResponse, isSearched, isMellieSearch, professionalMellieSearch,
        setSearchInput, searchInput, currentPage, setCurrentPage, paginationpageCount, getHomeAll, getAppliedDatas, getSavedDatas,
        filteringObject, sortByForPagination, handleApplyFilter, applyFilterCount
    } = useContext(CommonContext);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber.selected);
        const obj = {
            search_text: searchInput.trim(),
            page_number: pageNumber.selected + 1
        }

        if (window.location.pathname === "/professional/all_jobs") {
            if (isSearched || isMellieSearch) {
                setapplyFilterResponse(true);
                professionalMellieSearch(filteringObject, pageNumber.selected + 1);
            } else {
                getHomeAll("pagination", pageNumber.selected + 1, sortByForPagination)
            }
        }

        if (window.location.pathname === "/professional/applied_jobs") {
            if (searchInput) {
                setapplyFilterResponse(true);
                sendingDataForProfessionalSearch("/search_result_applied", obj);
            } else {
                setSearchInput("");
                getAppliedDatas("pagination", pageNumber.selected + 1, sortByForPagination)
            }
        }

        if (window.location.pathname === "/professional/saved_jobs") {
            if (searchInput) {
                setapplyFilterResponse(true);
                sendingDataForProfessionalSearch("/search_result_saved", obj);
            } else {
                setSearchInput("");
                getSavedDatas("pagination", pageNumber.selected + 1, sortByForPagination)
            }
        }
    }


    return (
        <>
            <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={'...'}
                pageCount={paginationpageCount}
                forcePage={currentPage}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                onPageChange={handlePageClick}
                containerClassName={"pagination justify-content-center mb-0"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link "}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
            />
        </>
    )
}

export default HomePagination
